import React from "react";
import Link from "helpers/link";
import RichText from "components/rich-text";
import Image from "components/image";
import formatDate from "helpers/format-date";
import Button from "components/button";
import { useGlobalContext } from "context/global";
import { formatTitle } from "helpers/format-title";

const BlogHighlights = ({ data }) => {
	const { translation, langCode  } = useGlobalContext();

	const { blogs, button, content } = data;

	const MainBlog = ({ blog }) => (
		<article className="w-full block flex-col items-start md:w-2/5 md:flex">
			<div className="relative">
				<Image className="h-64" image={blog.featuredImage} alt={blog.featuredImage?.alt} />
				<span className="pill-label-white">{blog?.label}</span>
			</div>
			<div className="flex flex-col gap-4 mt-3 md:mt-[3.75em] md:flex md:flex-col md:items-start md:justify-between">
				<span className="text-secondary font-body text-small md:text-sm uppercase">{formatDate(blog.date, langCode)}</span>
				<Link to={`/blogs/${blog.category.handle}/${blog.handle}`}>
					<h3 className="font-normal font-base">{formatTitle(blog.title)}</h3>
				</Link>
				<p className="text-secondary">{blog.excerpt}</p>
				<Link to={`/blogs/${blog.category.handle}/${blog.handle}`} className="btn-read-more text-center">
					{translation?.blog?.readMore}
				</Link>
			</div>
		</article>
	);

	const SideBlog = ({ blog }) => (
		<article className="w-1/2 gap-x-3 md:w-full md:flex">
			<div className="relative md:w-1/2">
				<Image className="w-full md:h-64" image={blog.featuredImage} alt={blog.featuredImage?.alt} />
				<span className="pill-label-white">{blog?.label}</span>
			</div>
			<div className="mt-3 md:mt-0 md:flex md:flex-col md:items-start md:justify-between md:w-1/2 md:gap-y-3">
				<span className="text-secondary font-body text-small md:text-sm uppercase">{formatDate(blog.date, langCode)}</span>
				<Link to={`/blogs/${blog.category.handle}/${blog.handle}`}>
					<h3 className="font-normal font-base">{formatTitle(blog.title)}</h3>
				</Link>
				<span className="text-secondary text-small md:text-sm hidden md:block">{blog.excerpt}</span>
				<Link to={`/blogs/${blog.category.handle}/${blog.handle}`} className="btn-read-more hidden md:block">
					{translation?.blog?.readMore}
				</Link>
			</div>
		</article>
	);

	return (
		<div className="w-11/12 m-auto my-20 hd-screen-max-width">
			<div className="text-center w-full m-auto md:w-1/2">
				<RichText value={content} />  
			</div>

			<div className="md:flex mt-10 md:gap-x-16 gap-x-3">
				<MainBlog blog={blogs[0]} />
				<div className="w-full mt-10 flex justify-start md:flex md:flex-col md:w-1/2 md:mt-0 gap-2 md:gap-[3.75em]">
					{blogs.slice(1).map((blog) => <SideBlog key={blog.handle} blog={blog} />)}
				</div>
			</div>

			<Button data={button} className="mt-10 btn-center" />
		</div>
	);
};

export default BlogHighlights;
